import store from "../redux/store";

export function useIsAdmin(): boolean {
  const user = store.getState().auth.user;
  const userRoles = user?.roles || [];
  return userRoles.includes('admin');
}